var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"bank-profile-container-row",attrs:{"justify":"center"}},[_c('v-col',{staticClass:"bank-profile-side-panel",attrs:{"cols":"2"}},[_c('app-bank-and-profile-side-panel')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }